import React from 'react';
import team6Picture from '../../assets/kominfo-team-6.png';

export default () => {
  return (
    <section className="psre-tujuh">
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12 col-12 col-psre-tujuh">
          <form action="https://mailto:?Subject=Tanya%20PSrE" method="post" enctype="text/plain">
            <div className="col-lg-8 col-md-9 col-sm-12 col-12 mx-auto">
              <p className="mb-5 text-center" style={{color: 'white', fontSize: '18px'}}>Hubungi Kami</p>
              <div className="input-group mb-3">
                <div className="input-group-prepend"><span className="input-group-text" id="basic-addon1"><i className="fa fa-envelope"></i></span></div>
                <input className="form-control" type="text" placeholder="Alamat Email Anda" name="Email" />
              </div>
              <div className="input-group mb-3">
                <div className="input-group-prepend"><span className="input-group-text" id="basic-addon1"><i className="fa fa-user-alt"></i></span></div>
                <input className="form-control" type="text" placeholder="Nama Anda" name="Nama" />
              </div>
              <textarea className="form-control" name="Pesan" rows="5" placeholder="Tulis Pesan Anda Disini"></textarea>
              <button className="btn-yellow btn" type="submit">Kirim Pesan</button>
            </div>
          </form>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 col-12 d-lg-block d-md-block d-sm-none d-none">
          <img src={team6Picture} alt="kominfo-team" style={{width: '100%', height: 'auto'}}/>
        </div>
      </div>
    </section>
  )
}